import { NgModule } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '@app/modules/shared.module';
import { UtilsModule } from '@app/modules/utils.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomFormsModule } from '@app/modules/forms.module';
import { LoginBaseComponent } from '@sharedTemplates/login/login.base.component';
import { LoginP1012Component } from './p1012/login-p1012.component';

const routes: Routes = [
  {
    path: '',
    component: LoginBaseComponent,
  },
];

@NgModule({
  declarations: [LoginBaseComponent, LoginP1012Component],
  exports: [LoginP1012Component, LoginBaseComponent],
  imports: [AsyncPipe, CommonModule, SharedModule, UtilsModule, RouterModule.forChild(routes), CustomFormsModule, ReactiveFormsModule],
})
export class LoginBaseModule {}
